/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Header, Footer, Loading } from '../../../components/index'
import { WebApi } from '../../../api/web'
import { CgDanger } from 'react-icons/cg'
import { GregorianToJalali, TimeAgo } from '../../../utilities/convertTime'
import { NumberWithCommas } from '../../../utilities/generator'
import { FixNumbers } from '../../../utilities/convertType'
import { UploadsUrl } from '../../../services/url'
import { fontSize } from '@mui/system'
const SingleDocument = () => {
  const { id } = useParams()
  const [lawyer, setLawyer] = useState(null)
  const [document, setDocument] = useState(null)
  const [SessionCourtState, setSessionCourtState] = useState(null)
  const [SessionOnlineState, setSessionOnlineState] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    Document()
  }, [])
  const Translate = {
    1: 'در انتظار پرداخت',
    2: 'درحال بررسی',
    3: 'پرداخت موفق',
    4: 'پرداخت ناموفق',
  }
  const Document = async () => {
    let ArraySessionCourt = []
    let ArraySessionOnline = []
    await WebApi.document(id)
      .then((res) => {
        setDocument(res.data.data.document)
        setLawyer(res.data.data.document.lawyer)
        for (let i = 1; i <= res.data.data.document.countSessionCourt; i++) {
          ArraySessionCourt.push(i)
        }
        for (let i = 1; i <= res.data.data.document.countSessionOnline; i++) {
          ArraySessionOnline.push(i)
        }
        setSessionCourtState(ArraySessionCourt)
        setSessionOnlineState(ArraySessionOnline)
      })

      .catch((err) => {})
  }

  const OrderPayment = async (payment) => {
    if (payment.status == 1 || payment.status == 4) {
      await WebApi.orderDocumentPayment(payment._id)
        .then((res) => {
          window.location.href = res.data.data.orderDocumentPayment.url
        })
        .catch((err) => {})
    }
  }

  return (
    <>
      {document && <Header title={` پرونده شماره ${document.number}`} />}
      {loading && <Loading />}
      {lawyer && document && SessionCourtState && SessionOnlineState ? (
        <div className='container'>
          <div className='template-pages'>
            <div className='top-section-single justify-content-center'>
              <div className='avatar'>
                <img
                  className='box-shadow'
                  src={`${UploadsUrl}/${lawyer.avatar}`}
                  alt='user'
                />
              </div>
            </div>
            <div className='about-lawer set-calendar'>
              <div>
                <h2>{`${lawyer.fname} ${lawyer.lname}`}</h2>
                <h5>{lawyer.title}</h5>
              </div>
              <div className='license-number'>
                <span>شماره پروانه وکالت</span>
                <span>{document.number}</span>
              </div>
            </div>
            <div className='layer-shadow'></div>
            <div className='status-single-document'>
              <div className='nav'>
                <div className='item'>
                  <span>
                    <CgDanger size={25} />
                  </span>
                  <h5>وضعیت پرونده</h5>
                </div>
                <div className='item'>
                  <span>{Translate[document.status]}</span>
                  <div className='precent'>{document.percent} %</div>
                </div>
              </div>
              <div className='nav'>
                <div className='item'>
                  <span>
                    <img src='/svg/Filter.svg' alt='Filter' />
                  </span>
                  <h5>تاریخ اتمام پرونده</h5>
                </div>
                <div style={{ color: '#777777', fontSize: '14px' }}>
                  {TimeAgo(document.finishedAt)}
                </div>
              </div>
            </div>
            <div className='layer-shadow'></div>
            <div className='countSessionCourt'>
              <div className='title'>
                <h4>تعداد جلسات دادگاه</h4>
              </div>
              <Session count={SessionCourtState} />
            </div>
            <div className='layer-shadow'></div>
            <div className='countSessionOnline'>
              <div className='title'>
                <h4>تعداد جلسات آنلاین</h4>
              </div>
              <Session count={SessionOnlineState} />
            </div>
            <div className='layer-shadow'></div>
            <div className='payment-document'>
              <div className='title'>
                <h4>پرداختی ها</h4>
              </div>
              {document.payments.map((payment, index) => (
                <div className='nav' key={index}>
                  <div>
                    <h5>مبلغ {NumberWithCommas(payment.amount)} تومان</h5>
                  </div>
                  <div
                    className={`type-${payment.status}`}
                    onClick={() => OrderPayment(payment)}
                  >
                    {Translate[payment.status]}
                  </div>
                </div>
              ))}
            </div>
            <div className='layer-shadow'></div>
            <div className='description-document'>
              <div className='title'>
                <h4>یاداشت وکیل</h4>
              </div>
              <p>{document.description}</p>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
      <Footer />
    </>
  )
}
export default SingleDocument

const Session = ({ count }) => {
  if (count.length > 6) {
    return (
      <div className='count-session'>
        <span>{count[0]}</span>
        <span>{count[1]}</span>
        <span className='etc'>...</span>
        <span>{count[count.length - 2]}</span>
        <span className='active'>{count[count.length - 1]}</span>
      </div>
    )
  } else {
    return (
      <div className='count-session'>
        {count.map((item) => (
          <span className={count.length == item ? 'active' : ''}>{item}</span>
        ))}
      </div>
    )
  }
}
